import { createAction } from 'redux-act';

export const maintenanceDetected = createAction('MAINTENANCE_DETECTED');
export const maintenanceRecovered = createAction('MAINTENANCE_RECOVERED');
export const maintenanceCheckNow = createAction('MAINTENANCE_CHECK_NOW');
